// src/pages/admin/integrations/zoho/components/ZohoTabs.tsx
import type { FC } from 'react';
import { ZohoTabKey } from '../../../types/integrations';
import { TABS } from '../../../util/Constants';


interface ZohoTabsProps {
  active: ZohoTabKey;
  onChange: (key: ZohoTabKey) => void;
  connected: boolean;
}

const ZohoTabs: FC<ZohoTabsProps> = ({ active, onChange, connected }) => {
  return (
    <nav className="flex gap-1 border-b border-slate-200 mb-6 overflow-x-auto">
      {TABS?.map(([k, l]) => {
        const label = k === 'connect' && connected ? 'Connection' : l;
        return (
          <button
            key={k}
            type="button"
            role="tab"
            aria-selected={active === k}
            onClick={() => onChange(k)}
            className={`px-4 py-2 text-sm font-medium border-b-2 whitespace-nowrap transition-colors ${
              active === k
                ? 'border-blue-600 text-blue-600'
                : 'border-transparent text-slate-500 hover:text-slate-700'
            }`}
          >
            {label}
          </button>
        );
      })}
    </nav>
  );
};

export default ZohoTabs;